import type { Component } from '@tmh-website/components/blocks.types';
import { Color } from '@tmh-website/shared/colors';
import { ButtonHoverThemeColor, ButtonThemeColor } from '@tmh-website/ui/Button';
import { ContactCardThemeColor } from './ContactCard.theme';

export type ContactSupportThemeColor = Component<'content.contact-support'>['backgroundColor'];

export interface ContactSupportTheme {
  background: Color;
  text: Color;
  surface: Color;
  sidebarButtonThemeColor: ButtonThemeColor;
  buttonThemeColor: ButtonThemeColor;
  buttonHoverThemeColor: ButtonHoverThemeColor;
  contactCardThemeColor: ContactCardThemeColor;
}

export const contactSupportThemes: { [key in ContactSupportThemeColor]: ContactSupportTheme } = {
  /**
   * This theme variant has been added WITHOUT designs using the AI-generated color scheme, based on the TMH styleguide.
   *
   * @see https://mobilityhouse.atlassian.net/browse/WEBSITE23-374
   */
  [Color.Green_1000_Energy]: {
    background: Color.Green_1000_Energy,
    text: Color.Neutral_0_White,
    surface: Color.Green_900,
    sidebarButtonThemeColor: Color.Neutral_0_White,
    buttonThemeColor: Color.Blue_500_Ultramarine,
    buttonHoverThemeColor: Color.Blue_1000_Deep,
    contactCardThemeColor: Color.Green_1000_Energy,
  },

  [Color.Neutral_0_White]: {
    background: Color.Neutral_0_White,
    text: Color.Blue_1000_Deep,
    surface: Color.Neutral_200_OffWhite,
    sidebarButtonThemeColor: Color.Neutral_0_White,
    buttonThemeColor: Color.Blue_500_Ultramarine,
    buttonHoverThemeColor: Color.Blue_1000_Deep,
    contactCardThemeColor: Color.Neutral_200_OffWhite,
  },
  [Color.Neutral_200_OffWhite]: {
    background: Color.Neutral_200_OffWhite,
    text: Color.Blue_1000_Deep,
    surface: Color.Neutral_0_White,
    sidebarButtonThemeColor: Color.Neutral_200_OffWhite,
    buttonThemeColor: Color.Blue_500_Ultramarine,
    buttonHoverThemeColor: Color.Blue_1000_Deep,
    contactCardThemeColor: Color.Neutral_200_OffWhite,
  },

  /**
   * This theme variant has been added WITHOUT designs using the AI-generated color scheme,
   * based on the previously defined color variants.
   *
   * @see https://mobilityhouse.atlassian.net/browse/EW-329
   */
  [Color.Neutral_950_TechDarkGrey]: {
    background: Color.Neutral_950_TechDarkGrey,
    text: Color.Neutral_0_White,
    surface: Color.Neutral_900,
    sidebarButtonThemeColor: Color.Neutral_0_White,
    buttonThemeColor: Color.Blue_500_Ultramarine,
    buttonHoverThemeColor: Color.Blue_1000_Deep,
    contactCardThemeColor: Color.Neutral_950_TechDarkGrey,
  },
};
